import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";
import { ProjectScheduleFrequency, ProjectScheduleReference } from "../../shared/db";
import { doPROJECT_SET, doREQUEST_ERROR, doREQUEST_COMPLETE } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_PROJECT_CREATE = "REQUEST_PROJECT_CREATE";
export const doREQUEST_PROJECT_CREATE = createDoRequestAction(REQUEST_PROJECT_CREATE);

export const requestProjectCreateActionCreators = {
  doREQUEST_PROJECT_CREATE,
};

export function* requestProjectCreate({ payload, setRequestResult }: any): SagaIterator {
  debug("saga*requestProject");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        name: v.string().exist(),
        investigator: v.string().optional(),
        organization: v.string().optional(),
        description: v.string().optional(),
        workspaceId: v.string().uuid().optional(),
        type: v.string().valid("template", "sample", "user").optional(),
        scheduleConfig: v
          .object({
            frequency: v
              .string()
              .allow(...Object.values(ProjectScheduleFrequency), null)
              .exist(),
            reference: v
              .string()
              .allow(...Object.values(ProjectScheduleReference), null)
              .exist(),
            absoluteReferenceYymmdd: v
              .number()
              .integer()
              .min(100000)
              .max(999999)
              .allow(null)
              .exist(),
          })
          .optional(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_CREATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { name, investigator, organization, description, workspaceId, scheduleConfig } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/project-create`,
    accessToken,
    data: {
      name,
      investigator,
      organization,
      description,
      workspaceId,
      scheduleConfig,
    },
  });

  // handle error
  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_CREATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/project-create",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(doPROJECT_SET(result.payload));

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_CREATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* projectCreateSaga() {
  yield takeEvery(REQUEST_PROJECT_CREATE, requestProjectCreate);
}
